<template>
  <div class="modal fade" ref="modalRef" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" :class="size">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" @click="hide"></button>
        </div>
        <div class="modal-body">
          <!-- si el padre provee contenido por slot se muestra directamente -->
          <div v-if="$slots.default">
            <slot />
          </div>
          <!-- de lo contrario usamos la prop mensaje, renderizándola como HTML -->
          <p v-else v-html="message"></p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="hide">Entendido</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
/* global defineProps, defineExpose */
import { onMounted, ref } from 'vue';
// Importamos el objeto Modal de la librería de Bootstrap (instalada vía npm)
import { Modal } from 'bootstrap';

// eslint-disable-next-line no-undef
// eslint-disable-next-line no-undef
const props = defineProps({
  title: { type: String, default: 'Notificación' },
  message: { type: String, default: '' },
  // Bootstrap modal size class (e.g. 'modal-lg', 'modal-xl'). Leave empty for default.
  size: { type: String, default: 'modal-lg' }
});

// Mantener reactividad al acceder a las props desde el template
import { computed } from 'vue';
const title = computed(() => props.title);
const message = computed(() => props.message);
const size = computed(() => props.size);

const modalRef = ref(null);
let modalInstance = null;

// Inicializamos el modal cuando el componente se monta
onMounted(() => {
  modalInstance = new Modal(modalRef.value);
});

// Funciones para controlar el modal desde el padre
const show = () => modalInstance.show();
const hide = () => modalInstance.hide();

// Exponemos los métodos para que el padre pueda llamarlos
// eslint-disable-next-line no-undef
defineExpose({ show, hide });
</script>